import { render, staticRenderFns } from "./work-order-lots.html?vue&type=template&id=8839c47e&scoped=true&"
import script from "./work-order-lots.js?vue&type=script&lang=js&"
export * from "./work-order-lots.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8839c47e",
  null
  
)

export default component.exports